class RegisterForm {
  constructor() {
    this.registerFormInit();
    this.registerInputs();
  }

  registerInputs = () => {
    const form = document.querySelector(".js-reg-form");
    const mainInput = document.querySelector(".js-reg-input-main");
    const firstName = document.querySelector(".js-reg-billing-first-name");
    const lastName = document.querySelector(".js-reg-billing-last-name");
    const username = document.querySelector(".js-reg-username");

    if (!form) {
      return;
    }
    form.addEventListener("submit", () => {
      if (mainInput.value) {
        let split = mainInput.value.split(" ");
        username.value = mainInput.value.replace(" ", "-").toLowerCase();
        firstName.value = split[0];
        if (split.length > 1) {
          lastName.value = split[1];
        }
        return true;
      } else {
        return false;
      }
    });
  };

  registerFormInit = () => {
    const labels = document.querySelectorAll(".js-register-label");
    labels.forEach((label) => {
      let input = label.querySelector("input");
      if (input.value != "") {
        label.classList.add("input");
      }
      input.addEventListener("animationstart", (e) => {
        if (e.animationName == "onAutoFillStart") {
          label.classList.add("active");
        }
      });
      input.addEventListener("focus", () => {
        labels.forEach((l) => {
          if (l != label) {
            l.classList.remove("active");
          }
        });
        label.classList.add("active");
      });
      input.addEventListener("input", (e) => {
        if (e.target.value != "") {
          label.classList.add("input");
        } else {
          label.classList.remove("input");
        }
      });
    });
  };
}

new RegisterForm();
